import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  dateFormatter,
  dropdownFetch,
  getCurrentDateTime,
  getDateDifference,
  getKeyPathValue,
  request,
  toast
} from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { IPDSearchHandler } from './utils';
import { DISCHARGE_SUMMARY, GENDER_DROPDOWN } from '../../../../../constants';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { DischargeSummaryMedicineDetailsForm } from './DischargeSummaryMedicineDetailsForm';
import { DischargeSummaryAddDiagnosForm } from './DischargeSummaryAddDiagnosForm';
import { IpdSearchHandlerDischargeSummary } from './utils/IpdSearchHandlerDischargeSummary';
import { IcpDiagnosisDetailsForm } from './IcpDiagnosisDetailsForm';
import { IcdDiagnosisDetailsForm } from './IcdDiagnosisDetailsForm';
import { CKEditor } from '@ckeditor/ckeditor5-react';  // Corrected import
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

function formatDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
const ADD_DIAGNOS_HEADER = [
  {
    header: 'Add Diagnos',
    accessor: 'add_diagnos',
    width: '30%'
  }
];


const TABLE_HEADER = [
  {
    header: 'IPD No. ',
    accessor: 'ipd_no'
  },
  {
    header: 'UHID',
    accessor: 'uhid'
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.patient_name}`}
        </span>
      );
    }
  },
  {
    header: 'Mobile No.',
    accessor: 'mobile'
  },
  {
    header: 'Admit Date',
    accessor: (row) => formatDate(row?.adm_date)
  },
  {
    header: 'Discharge Date',
    accessor: (row) => formatDate(row?.dis_date)
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const MEDICINE_TABLE_HEADER = [
  {
    header: 'Medicine Name',
    accessor: 'name'
  },
  {
    header: 'Unit',
    accessor: 'unit'
  },
  {
    header: 'Frequency',
    accessor: 'frequency'
  },
  {
    header: 'Dose',
    accessor: 'dose'
  },
  {
    header: 'Morning',
    accessor: (row) => `${row.morning === 'true' ? 'YES' : '-'}`
  },
  {
    header: 'Noon',
    accessor: (row) => `${row.noon === 'true' ? 'YES' : '-'}`
  },
  {
    header: 'Evening',
    accessor: (row) => `${row.evening === 'true' ? 'YES' : '-'}`
  },
  {
    header: 'Night',
    accessor: (row) => `${row.night === 'true' ? 'YES' : '-'}`
  },
  {
    header: 'Days',
    accessor: 'days'
  }
];


const TEMPLATE_TABLE_HEADER = [
  {
    header: 'Heading',
    accessor: 'heading'
  },
  {
    header: "Status",
    accessor: "status"
  }
];

const initialDischargeSummaryDataObj = {
  data: [],
  loading: false
};

export const DischargeSummary = () => {
  const doctorIDRef = useRef();
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [dischargeSummaryObj, setDischargeSummaryObj] = useState(initialDischargeSummaryDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [IPDSearchDialogOpen, setIPDSearchDialogOpen] = useState(false);
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [addDetailsDialogOpen, setAddDetailsDialogOpen] = useState(false);
  const [medicineDetailList, setmedicineDetailList] = useState([]);
  const [addDiagnosDialogOpen, setAddDiagnosDialogOpen] = useState(false);
  const [diagnos, setDiagnos] = useState([]);
  const [input, setInput] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [dischargeSummaryData, setDischargeSummaryData] = useState([]);
  const [medicineDropdown, setMedicineDropdown] = useState([]);
  const [doseDropdown, setDoseDropdown] = useState([]);
  const [frequencyDropdown, setFrequencyDropdown] = useState([]);
  const [icdDropdown, setIcdDropdown] = useState([]);
  const [icpDropdown, setIcpDropdown] = useState([]);
  const [icdDialogueOpen, setIcdDialogueOpen] = useState(false);
  const [icpDialogueOpen, setIcpDialogueOpen] = useState(false);
  const [dischargeSummaryTemplateList, setDischargeSummaryTemplateList] = useState([])
  const [selectedRows, setSelectedRows] = useState([])
  const [editorData, setEditorData] = useState('');


  const user = JSON.parse(localStorage.getItem('user'));
  const isEnabledDate =
    user && user.permissions ? user.permissions.some((permission) => permission.includes('DatePermission')) : false;
  const [doctorDropdown, setDoctorDropdown] = useState([]);
  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor');
    setDoctorDropdown(data);
  }, []);

  const getIcpDropdown = useCallback(async () => {
    const data = await dropdownFetch('icp-diagnosis');
    setIcpDropdown(data);
  }, []);

  const getIcdDropdown = useCallback(async () => {
    const data = await dropdownFetch('mrd-diagnosis');
    setIcdDropdown(data);
  }, []);

  const getMedicineDropdown = useCallback(async () => {
    const data = await dropdownFetch('product-master');
    setMedicineDropdown(data);
  }, []);

  const getDoseDropdown = useCallback(async () => {
    const data = await dropdownFetch('dose-master');
    setDoseDropdown(data);
  }, []);

  const getFrequencyDropdown = useCallback(async () => {
    const data = await dropdownFetch('frequency-master');
    setFrequencyDropdown(data);
  }, []);

  useEffect(() => {
    getDoctorDropdown();
    getMedicineDropdown();
    getDoseDropdown();
    getFrequencyDropdown();
    getIcpDropdown();
    getIcdDropdown();
  }, [getDoctorDropdown, getMedicineDropdown, getDoseDropdown, getFrequencyDropdown, getIcpDropdown, getIcdDropdown]);

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
    },
    mode: 'all'
  });

  const { handleSubmit, watch, reset, setValue } = methods;
  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, '', [
        '_id',
        '__v',
        'status',
        'createdAt',
        'beds',
        'medicine'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      const formattedRegDate = selectedRecord?.date ? new Date(selectedRecord.date).toISOString().split('T')[0] : '';
      setValue('date', formattedRegDate);
      if (selectedRecord.dob) {
        const dobFormatted = new Date(selectedRecord.dob).toISOString().split('T')[0];
        setValue('dob', dobFormatted);

        // Calculate age from DOB
        const dobDate = new Date(selectedRecord.dob);
        const currentDate = new Date();
        let age = currentDate.getFullYear() - dobDate.getFullYear();
        const monthDiff = currentDate.getMonth() - dobDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < dobDate.getDate())) {
          age--;
        }
        setValue('age_year', age);
      }
      setDiagnos(selectedRecord.diagnos);
      setmedicineDetailList(selectedRecord.medicine);
      setEditorData(selectedRecord?.general_examination)
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/discharge-summary-edit' : '/discharge-summary-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...formValues,
        medicine: medicineDetailList,
        general_examination: editorData,
        diagnos: diagnos,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Discharge Summary`, { variant: 'success' });
      setSelectedRecord(response?.data?.data || response?.data);
      setCurrentAction('');
      setmedicineDetailList([]);
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Discharge Summary`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setDischargeSummaryObj({ loading: true });
    const limit = 10;
    const response = await request('/discharge-summary-list', {
      method: 'GET',
      query: { limit: limit }
    });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setDischargeSummaryObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setDischargeSummaryObj({ loading: false });
    }
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/discharge-summary-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancel Indoor Registeration', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Cancel Indoor Registeration', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/discharge-summary-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Indoor Registeration', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Indoor Registeration', { variant: 'error' });
    }
    setLoading(false);
  };

  const dobWatch = watch('dob');

  useEffect(() => {
    if (!dobWatch) return;
    const dobDate = new Date(dobWatch);
    if (dobDate >= Date.now()) {
      toast('DOB cannot be of future', { variant: 'error' });
      return;
    }
    const { year, month, day } = getDateDifference(new Date(dobWatch));
    setValue('age_year', year);
  }, [setValue, dobWatch]);

  const handleActiveTab = (newTabIndex) => {
    setActiveTab(newTabIndex);
  };

  const searchIPDDetails = async (ipd_no) => {
    setLoading(true);
    const response = await request('/indoor-registeration-detail', {
      method: 'GET',
      params: ipd_no
    });
    if (response?.success) {
      if (!response?.data) {
        toast('No IPD found', { variant: 'warning' });
      } else {
        const { data: patientData } = response;
        setValue('ipd_no', ipd_no);
        setValue('dob', getCurrentDateTime('date', patientData.dob)?.split('-').reverse().join('-'));
        setValue('uhid', patientData.uhid);
        setValue('address', patientData.patient.address.address);
        setValue('adm_date', getCurrentDateTime('date', patientData.admissionDate).split('-').reverse().join('-'));
        setValue(
          'dis_date',
          getCurrentDateTime('date', patientData.patientDischarge?.date).split('-').reverse().join('-')
        );
        const dobDate = new Date(patientData.patient.dob);
        const currentDate = new Date();
        let age = currentDate.getFullYear() - dobDate.getFullYear();
        const monthDiff = currentDate.getMonth() - dobDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < dobDate.getDate())) {
          age--;
        }

        setValue('age_year', age); // Set calculated age
        setValue('gender', patientData.patient.gender);
        setValue('department', patientData.patient.department.department);
        setValue('doctor', patientData.consultant_detail?.doctor?.name);
        setValue('patient_name', `${patientData.patient.first_name} ${patientData.patient.last_name} `);
        setValue('sponsor', patientData.patient.sponsor?.name);
        setValue('mobile', patientData.patient.address?.mobile);
      }
    } else {
      toast('Failed to load patient details', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleMedicineDelete = (rowId) => {
    setmedicineDetailList((prev) => prev.filter((data) => data.medicine_name !== rowId));
  };

  const handleDiagnosDelete = (rowId) => {
    setDiagnos((prev) => prev.filter((data) => data.add_diagnos !== rowId));
  };

  useEffect(() => {
    if (dischargeSummaryObj.data && dischargeSummaryObj.data.length > 0) {
      setDischargeSummaryData(dischargeSummaryObj.data);
      setIsFiltered(false);
    }
  }, [dischargeSummaryObj.data]);


  useEffect(() => {
    handleUhidSearch();
  }, [input])

  const handleUhidSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    const limit = 10;
    try {
      const response = await request('/discharge-summary-list', {
        method: 'GET',
        query: { patient_name: lowercasedInput, limit: limit }
      });
      if (response.success && Array.isArray(response.data)) {
        setDischargeSummaryObj({ loading: false, data: response.data });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setDischargeSummaryObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setDischargeSummaryObj({ loading: false, data: [] });
    }
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };


  const fetchTemplateMaster = async () => {
    setDischargeSummaryTemplateList({ loading: true });
    const response = await request('/discharge-summary-template-master-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setDischargeSummaryTemplateList({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setDischargeSummaryTemplateList({ loading: false });
    }
  };

  useEffect(() => {
    fetchTemplateMaster()
  }, [])

  const isSelected = (row, field) => {
    const selectedRow = selectedRows.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSelect = (row, field) => {
    if (!row || !field) {
      console.warn('Row data or field is undefined. Check the input.');
      return;
    }

    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      setSelectedRows([]);
      return;
    }

    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);

      if (existingRow) {
        const updatedRows = prevSelectedRows.map((selectedRow) =>
          selectedRow._id === row._id
            ? { ...selectedRow, [field]: !existingRow[field] }
            : selectedRow
        );

        return updatedRows.filter((row) => row.ok);
      } else {
        return [
          ...prevSelectedRows,
          { ...row, [field]: true, ok: field === 'ok' || '' },
        ];
      }
    });
  };


  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setEditorData(data);
    console.log({ data });
  };

  useEffect(() => {
    if (selectedRows && selectedRows.length > 0) {
      // Combine all the `details` of the selected rows
      const combinedDetails = selectedRows
        .map(row => row.details)  // Get the `details` from each row
        .join('\n\n');  // Combine them into a single string with a newline between each

      setEditorData(combinedDetails);  // Set the combined details to the editor
    } else {
      // If selectedRows is empty, clear the editorData
      setEditorData('');
    }
  }, [selectedRows]);  // This triggers whenever `selectedRows` changes


  console.log(selectedRows, "HELLO SLEECTEDROWS")

  console.log(editorData, "HELLO EDITOR")

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: '100vw',
            boxSizing: 'border-box',
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Discharge Summary
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setmedicineDetailList([]);
                    setDiagnos([]);
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id} `, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Summary type</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      name="summary_type"
                      placeholder="Summary type"
                      menus={DISCHARGE_SUMMARY}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Ipd No.</Typography>
                    <TextField
                      sx={{ flex: 0.7 }}
                      inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                      name="ipd_no"
                      placeholder="Ipd No."
                      disabled
                    />
                    <Button
                      onClick={() => setIPDSearchDialogOpen(true)}
                      disabled={!['new'].includes(currentAction)}
                      sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                      variant="contained"
                    >
                      <SearchIcon />
                    </Button>
                  </Stack>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>DocNo./Date</Typography>
                    <TextField sx={{ flex: 0.4 }} placeholder="Doc No." name="doc_no" disabled />
                    <TextField
                      sx={{ flex: 0.4 }}
                      placeholder="Date"
                      name="date"
                      type="date"
                      disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}></Grid>
                <Grid item xs={12}>
                  <Box sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(0)}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 900,
                        backgroundColor: activeTab === 0 ? 'primary.main' : 'default',
                        color: activeTab === 0 ? 'white' : 'text.primary'
                      }}
                    >
                      Patient Detail/Diagnos
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(1)}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 900,
                        backgroundColor: activeTab === 1 ? 'primary.main' : 'default',
                        color: activeTab === 1 ? 'white' : 'text.primary'
                      }}
                    >
                      Other Details
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(2)}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 900,
                        backgroundColor: activeTab === 2 ? 'primary.main' : 'default',
                        color: activeTab === 2 ? 'white' : 'text.primary'
                      }}
                    >
                      Clinical Examination
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(3)}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 900,
                        backgroundColor: activeTab === 3 ? 'primary.main' : 'default',
                        color: activeTab === 3 ? 'white' : 'text.primary'
                      }}
                    >
                      Lab
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(4)}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 900,
                        backgroundColor: activeTab === 4 ? 'primary.main' : 'default',
                        color: activeTab === 4 ? 'white' : 'text.primary'
                      }}
                    >
                      Radiology
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(5)}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 900,
                        backgroundColor: activeTab === 5 ? 'primary.main' : 'default',
                        color: activeTab === 5 ? 'white' : 'text.primary'
                      }}
                    >
                      Surgery Notes
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(6)}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 900,
                        backgroundColor: activeTab === 6 ? 'primary.main' : 'default',
                        color: activeTab === 6 ? 'white' : 'text.primary'
                      }}
                    >
                      Advice On Discharge
                    </Button>

                  </Box>
                </Grid>
                {activeTab === 0 && (
                  <>
                    <Grid item xs={4} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Ipd/Uhid</Typography>
                        <TextField disabled sx={{ flex: 0.4 }} name="ipd_no" />
                        <TextField disabled sx={{ flex: 0.4 }} name="uhid" />
                      </Stack>

                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Sponsor</Typography>
                        <TextField sx={{ flex: 0.8 }} disabled placeholder="Sponsor" name="sponsor" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Doctor</Typography>
                        <TextField sx={{ flex: 0.8 }} disabled placeholder="Doctor" name="doctor" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Dis. Mode</Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Discharge Mode"
                          name="patient_details.discharge_mode"
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={4} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                        <TextField sx={{ flex: 0.7 }} name="patient_name" placeholder="Patient Name" disabled />
                      </Stack>

                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Address</Typography>
                        <TextField sx={{ flex: 0.7 }} placeholder="Address" name="address" disabled />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Department</Typography>
                        <TextField sx={{ flex: 0.7 }} placeholder="Department" name="department" disabled />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Mobile</Typography>
                        <TextField sx={{ flex: 0.7 }} placeholder="Mobile No" name="mobile" disabled />
                      </Stack>
                    </Grid>
                    <Grid item xs={4} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>DOB/Gender </Typography>
                        <TextField
                          sx={{ flex: 0.4 }}
                          type="date"
                          name="dob"  // Changed from age_year to dob
                          disabled
                        />
                        <TextField
                          sx={{ flex: 0.4 }}
                          name="age_year"  // This shows the calculated age
                          placeholder="Age"
                          disabled
                        />
                        <TextField sx={{ flex: 0.4 }} name="gender" placeholder="Gender" disabled />
                      </Stack>

                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Adm/Dis Date</Typography>
                        <TextField sx={{ flex: 0.4 }} type="date" disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)} placeholder="Adm Date" name="adm_date" />
                        <TextField sx={{ flex: 0.4 }} type="date" disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)} placeholder="Dis Date" name="dis_date" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Jr. Res Doc</Typography>
                        <SelectTag
                          formControlSX={{ flex: 0.8 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Jr. Res Doc"
                          name="patient_details.jr_res_doc"
                          menus={doctorDropdown}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={1.5} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Button
                        variant="contained"
                        disabled={!['new', 'edit'].includes(currentAction)}
                        onClick={() => setAddDiagnosDialogOpen(true)}
                      >
                        Add Diagnos
                      </Button>
                    </Grid>

                    <Grid item xs={1.5} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Button
                        variant="contained"
                        disabled={!['new', 'edit'].includes(currentAction)}
                        onClick={() => setIcdDialogueOpen(true)}
                      >
                        ICD Diagnos
                      </Button>
                    </Grid>
                    <Grid item xs={1.5} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Button
                        variant="contained"
                        disabled={!['new', 'edit'].includes(currentAction)}
                        onClick={() => setIcpDialogueOpen(true)}
                      >
                        ICP Diagnos
                      </Button>
                    </Grid>

                    <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
                      <Table
                        containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                        columns={ADD_DIAGNOS_HEADER}
                        data={(diagnos && diagnos.map((data) => ({ _id: data.add_diagnos, ...data }))) || []}
                        // loading={diagnos.loading}
                        onDeleteHandler={handleDiagnosDelete}
                        showDeleteAction={true}
                      />
                    </Grid>
                  </>
                )}
                {activeTab === 1 && (
                  <>
                    <Grid container spacing={6}>
                      <Grid item xs={5.5} sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginLeft: '1%' }}>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <Typography fontWeight="bold" fontSize="12px">
                              Final Diagnosis
                            </Typography>
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              disabled={!['new', 'edit'].includes(currentAction)}
                              fullWidth
                              sx={{
                                '& .MuiInputBase-root': {
                                  height: '100%'
                                },
                                '& .MuiOutlinedInput-root': {
                                  padding: '5px'
                                }
                              }}
                              name="other_details.final_diagnosis"
                              multiline
                              rows={4}
                              placeholder="Final Diagnosis"
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={5.5} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Grid item>
                          <Typography fontWeight="bold" fontSize="12px">
                            Chief Complaints
                          </Typography>
                          <Divider />
                        </Grid>
                        <TextField
                          sx={{
                            flex: 1,
                            '& .MuiInputBase-root': {
                              height: '100%'
                            },
                            '& .MuiOutlinedInput-root': {
                              padding: '5px'
                            }
                          }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Chief Complaints"
                          name="other_details.chief_complaints"
                          multiline
                          rows={4}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={6}>
                      <Grid item xs={5.5} sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginLeft: '1%' }}>
                        <Grid item>
                          <Typography fontWeight="bold" fontSize="12px">
                            Past History
                          </Typography>
                          <Divider />
                        </Grid>
                        <TextField
                          sx={{
                            flex: 1,
                            '& .MuiInputBase-root': {
                              height: '100%'
                            },
                            '& .MuiOutlinedInput-root': {
                              padding: '5px'
                            }
                          }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Past History"
                          name="other_details.past_history"
                          multiline
                          rows={4}
                        />
                      </Grid>
                      <Grid item xs={5.5} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Grid item>
                          <Typography fontWeight="bold" fontSize="12px">
                            History
                          </Typography>
                          <Divider />
                        </Grid>
                        <TextField
                          sx={{
                            flex: 1,
                            '& .MuiInputBase-root': {
                              height: '100%'
                            },
                            '& .MuiOutlinedInput-root': {
                              padding: '5px'
                            }
                          }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="History"
                          name="other_details.history"
                          multiline
                          rows={4}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={6}>
                      <Grid item xs={5.5} sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginLeft: '1%' }}>
                        <Grid item>
                          <Typography fontWeight="bold" fontSize="12px">
                            Personal History
                          </Typography>
                          <Divider />
                        </Grid>
                        <TextField
                          sx={{
                            flex: 1,
                            '& .MuiInputBase-root': {
                              height: '100%'
                            },
                            '& .MuiOutlinedInput-root': {
                              padding: '5px'
                            }
                          }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Personal History"
                          name="other_details.personal_history"
                          multiline
                          rows={4}
                        />
                      </Grid>
                      <Grid item xs={5.5} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Grid item>
                          <Typography fontWeight="bold" fontSize="12px">
                            Other Investigation
                          </Typography>
                          <Divider />
                        </Grid>
                        <TextField
                          sx={{
                            flex: 1,
                            '& .MuiInputBase-root': {
                              height: '100%'
                            },
                            '& .MuiOutlinedInput-root': {
                              padding: '5px'
                            }
                          }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Other Investigation"
                          name="other_details.other_investigation"
                          multiline
                          rows={4}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={6}>
                      <Grid item xs={5.5} sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginLeft: '1%' }}>
                        <Grid item>
                          <Typography fontWeight="bold" fontSize="12px">
                            Surgery Details/Procedure Done
                          </Typography>
                          <Divider />
                        </Grid>
                        <TextField
                          sx={{
                            flex: 1,
                            '& .MuiInputBase-root': {
                              height: '100%'
                            },
                            '& .MuiOutlinedInput-root': {
                              padding: '5px'
                            }
                          }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Surgery Details"
                          name="other_details.surgery_detail"
                          multiline
                          rows={4}
                        />
                      </Grid>
                      <Grid item xs={5.5} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Grid item>
                          <Typography fontWeight="bold" fontSize="12px">
                            Course In Hospital
                          </Typography>
                          <Divider />
                        </Grid>
                        <TextField
                          sx={{
                            flex: 1,
                            '& .MuiInputBase-root': {
                              height: '100%'
                            },
                            '& .MuiOutlinedInput-root': {
                              padding: '5px'
                            }
                          }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Course In Hospital"
                          name="other_details.course_in_hospital"
                          multiline
                          rows={4}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={6}>
                      <Grid item xs={5.5} sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginLeft: '1%' }}>
                        <Grid item>
                          <Typography fontWeight="bold" fontSize="12px">
                            Condition At Discharge
                          </Typography>
                          <Divider />
                        </Grid>
                        <TextField
                          sx={{
                            flex: 1,
                            '& .MuiInputBase-root': {
                              height: '100%'
                            },
                            '& .MuiOutlinedInput-root': {
                              padding: '5px'
                            }
                          }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Condition At Discharge"
                          name="other_details.condition_at_discharge"
                          multiline
                          rows={4}
                        />
                      </Grid>
                      <Grid item xs={5.5} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Grid item>
                          <Typography fontWeight="bold" fontSize="12px">
                            Medicine
                          </Typography>
                          <Divider />
                        </Grid>
                        <TextField
                          sx={{
                            flex: 1,
                            '& .MuiInputBase-root': {
                              height: '100%'
                            },
                            '& .MuiOutlinedInput-root': {
                              padding: '5px'
                            }
                          }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Medicine"
                          name="other_details.medicine"
                          multiline
                          rows={4}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
                {activeTab === 2 && (
                  <>
                    <Grid item xs={5} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}>
                      <Grid item>
                        <Typography fontWeight="bold" fontSize={'12px'}>
                          General Physical Examination
                        </Typography>
                        <Divider />
                      </Grid>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>
                          Consiousness Level
                        </Typography>
                        <TextField sx={{ flex: 0.8 }} name="clinical_examination.consiouness_level" />
                      </Stack>

                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Pulse</Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Pulse"
                          name="clinical_examination.pulse"
                        />{' '}
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>BP</Typography>
                        <TextField
                          sx={{ flex: 0.4 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          name="clinical_examination.blood_pressure_systolic"
                          placeholder="Systolic"
                        />
                        <TextField
                          sx={{ flex: 0.4 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          name="clinical_examination.blood_pressure_diastolic"
                          placeholder="Diastolic"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Temprature</Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Temprature"
                          name="clinical_examination.temprature"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>RR</Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Respiratory Rate"
                          name="clinical_examination.respiratory_rate"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Chest</Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Chest"
                          name="clinical_examination.chest"
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={5} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column', marginTop: '2%' }}>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Cvs</Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Cvs"
                          name="clinical_examination.cvs"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Abdomen</Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Abdomen"
                          name="clinical_examination.abdomen"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Cns</Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Cns"
                          name="clinical_examination.cns"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Any Other</Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Any Other"
                          name="clinical_examination.any_other"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>
                          Local Examination
                        </Typography>
                        <TextField
                          sx={{ flex: 0.8 }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Local Examination"
                          name="clinical_examination.local_examination"
                        />
                      </Stack>
                    </Grid>
                  </>
                )}
                {activeTab === 3 && (
                  <>
                    <Grid container spacing={6}>
                      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginLeft: '1%' }}>
                        <Grid item>
                          <Typography fontWeight="bold" fontSize="12px">
                            Lab Investigation
                          </Typography>
                          <Divider />
                        </Grid>
                        <TextField
                          sx={{
                            flex: 1,
                            '& .MuiInputBase-root': {
                              height: '100%'
                            },
                            '& .MuiOutlinedInput-root': {
                              padding: '5px'
                            }
                          }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Lab Investigation"
                          name="lab.lab_investigation"
                          multiline
                          minRows={12}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
                {activeTab === 4 && (
                  <>
                    <Grid container spacing={6}>
                      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginLeft: '1%' }}>
                        <Grid item>
                          <Typography fontWeight="bold" fontSize="12px">
                            Radiology
                          </Typography>
                          <Divider />
                        </Grid>
                        <TextField
                          sx={{
                            flex: 1,
                            '& .MuiInputBase-root': {
                              height: '200px'
                            }
                          }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Radiology"
                          name="radiology.radiology"
                          multiline
                          minRows={12}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
                {activeTab === 6 && (
                  <>
                    <Button
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ p: 1, height: '100%', marginTop: '10px', marginLeft: '10px' }}
                      onClick={() => setAddDetailsDialogOpen(true)}
                      variant="contained"
                    >
                      Add Medicines
                    </Button>
                    <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Table
                        containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                        data={medicineDetailList.map((data) => ({ _id: data.medicine_name, ...data })) || []}
                        columns={MEDICINE_TABLE_HEADER}
                        size="small"
                        showDeleteAction={true}
                        onDeleteHandler={handleMedicineDelete}
                      />
                    </Grid>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ marginTop: '2%', marginLeft: '2%' }}>
                      <Typography sx={{ flex: 0.9, fontWeight: 700, fontSize: '1.4rem' }}>Next Follow Up</Typography>
                      <TextField
                        sx={{ flex: 0.8 }}
                        disabled={!['new', 'edit'].includes(currentAction)}
                        placeholder="Next Follow Up"
                        name="next_follow_up"
                      />
                    </Stack>
                    <Grid container spacing={6}>
                      <Grid item xs={5} sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginLeft: '1%' }}>
                        <Grid item>
                          <Typography fontWeight="bold" fontSize="14px">
                            Adviced
                          </Typography>
                          <Divider />
                        </Grid>
                        <TextField
                          sx={{
                            flex: 1,
                            '& .MuiInputBase-root': {
                              height: '100%'
                            },
                            '& .MuiOutlinedInput-root': {
                              padding: '5px'
                            }
                          }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Doctor Advice"
                          name="advice_on_discharge.doctor_advice"
                          multiline
                          rows={6}
                        />
                      </Grid>
                      <Grid item xs={5} sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginLeft: '15%' }}>
                        <Grid item>
                          <Typography fontWeight="bold" fontSize="14px">
                            Emergency Contact Details/When to Obtain Urgent Care
                          </Typography>
                          <Divider />
                        </Grid>
                        <TextField
                          sx={{
                            flex: 1,
                            '& .MuiInputBase-root': {
                              height: '100%'
                            },
                            '& .MuiOutlinedInput-root': {
                              padding: '5px'
                            }
                          }}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          placeholder="Emergency Contact Details"
                          name="advice_on_discharge.emergency_contact_details"
                          multiline
                          rows={6}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}

                {activeTab === 5 && (
                  <>
                    <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Table
                        containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                        data={dischargeSummaryTemplateList?.data || []}
                        columns={TEMPLATE_TABLE_HEADER}
                        size="small"
                        showOk={true}
                        isSelected={isSelected}
                        handleRowSelect={handleRowSelect}
                      />
                    </Grid>

                    <CKEditor
                      editor={ClassicEditor}
                      data={editorData || ''}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      onReady={(editor) => {
                        console.log('Editor is ready to use!', editor);
                      }}
                      onChange={handleEditorChange}
                      onBlur={(event, editor) => {
                        console.log('Blur.', editor);
                      }}
                      onFocus={(event, editor) => {
                        console.log('Focus.', editor);
                      }}
                    />
                  </>
                )}
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Discharge Summary Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient By Name"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={dischargeSummaryData || []}
          loading={dischargeSummaryObj.loading}
          onRowClick={(row) => {
            const { medicine, dose, frequency, ...others } = row;
            setSelectedRecord({
              ...others,
              medicine: medicine.map((data) => {
                const medicineDetail = medicineDropdown.find(({ _id }) => _id === data.medicine_name);
                const doseDetail = doseDropdown.find(({ _id }) => _id === data.dose_id._id);
                const frequencyDetail = frequencyDropdown.find(({ _id }) => _id === data.frequency_id._id);

                return {
                  ...data,
                  medicine: data.medicine_name,
                  name: medicineDetail?.main?.name || 'Unknown Medicine',
                  dose: doseDetail ? doseDetail.dose : 'Unknown Dose',
                  frequency: frequencyDetail ? frequencyDetail.frequency : 'Unknown Frequency'
                };
              })
            });

            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        PaperProps={{ sx: { p: 2 } }}
        open={IPDSearchDialogOpen}
        onClose={() => setIPDSearchDialogOpen(false)}
        scroll="body"
        maxWidth="xl"
      >
        <IpdSearchHandlerDischargeSummary onClose={() => setIPDSearchDialogOpen(false)} onAdd={searchIPDDetails} />
      </Dialog>
      <Dialog
        open={addDetailsDialogOpen}
        onClose={() => setAddDetailsDialogOpen(false)}
        PaperProps={{ sx: { p: 2, width: '35rem' } }}
        maxWidth="xl"
        scroll="body"
      >
        <DischargeSummaryMedicineDetailsForm
          onClose={() => setAddDetailsDialogOpen(false)}
          onAdd={(data) => {
            const [existingDetail] = medicineDetailList.filter(
              ({ medicine_name }) => medicine_name === data.medicine_name
            );
            if (existingDetail) {
              toast('Medicine already chosen', { variant: 'error' });
              return;
            }
            const medicineDetail = medicineDropdown.find(({ _id }) => _id === data.medicine_name);
            const doseDetail = doseDropdown.find(({ _id }) => _id === data.dose);
            const frequencyDetail = frequencyDropdown.find(({ _id }) => _id === data.frequency);
            if (medicineDetail && doseDetail && frequencyDetail) {
              const medicineName = medicineDetail.main?.name;
              const doseValue = doseDetail.dose;
              const frequencyValue = frequencyDetail.frequency;
              setmedicineDetailList((prev) => [
                ...prev,
                {
                  ...data,
                  _id: data.medicine_name,
                  dose_id: data.dose,
                  frequency_id: data.frequency,
                  name: medicineName,
                  dose: doseValue,
                  frequency: frequencyValue
                }
              ]);
            } else {
              toast('Medicine, dose, or frequency not found in dropdown', { variant: 'error' });
            }
          }}
          dose={doseDropdown}
          setDose={setDoseDropdown}
          medicine={medicineDropdown}
          setMedicine={setMedicineDropdown}
          frequency={frequencyDropdown}
          setFrequency={setFrequencyDropdown}
          getMedicineDropdown={getMedicineDropdown}
        />
      </Dialog>
      <Dialog
        open={addDiagnosDialogOpen}
        onClose={() => setAddDetailsDialogOpen(false)}
        PaperProps={{ sx: { p: 2, width: '35rem' } }}
        maxWidth="xl"
        scroll="body"
      >
        <DischargeSummaryAddDiagnosForm
          onClose={() => setAddDiagnosDialogOpen(false)}
          onAdd={(row) => {
            if (diagnos.some((diagnos) => diagnos.add_diagnos === row.add_diagnos)) {
              toast('Diagnos already taken', { variant: 'error' });
            } else {
              setDiagnos((prev) => [...prev, row]);
            }
          }}
        />
      </Dialog>
      {/* <Dialog
        PaperProps={{ sx: { p: 1 } }}
        open={IPDSearchDialogOpen}
        onClose={() => setIPDSearchDialogOpen(false)}
        scroll="body"
        maxWidth="xl"
      >
        <IpdSearchHandlerDischargeSummary onClose={() => setIPDSearchDialogOpen(false)} onAdd={searchIPDDetails} />
      </Dialog> */}
      <Dialog
        PaperProps={{ sx: { p: 2, width: '35rem' } }}
        open={icpDialogueOpen}
        onClose={() => setIcpDialogueOpen(false)}
        scroll="body"
        maxWidth="xl"
      >
        <IcpDiagnosisDetailsForm
          onClose={() => setIcpDialogueOpen(false)}
          icpDropdown={icpDropdown}
          onAdd={(row) => {
            if (diagnos.some((diagnos) => diagnos.add_diagnos === row.add_diagnos)) {
              toast('Diagnos already taken', { variant: 'error' });
            } else {
              setDiagnos((prev) => [...prev, row]);
            }
          }}
        />
      </Dialog>
      <Dialog
        PaperProps={{ sx: { p: 2, width: '35rem' } }}
        open={icdDialogueOpen}
        onClose={() => setIcdDialogueOpen(false)}
        scroll="body"
        maxWidth="xl"
      >
        <IcdDiagnosisDetailsForm
          onClose={() => setIcdDialogueOpen(false)}
          icdDropdown={icdDropdown}
          onAdd={(row) => {
            if (diagnos.some((diagnos) => diagnos.add_diagnos === row.add_diagnos)) {
              toast('Diagnos already taken', { variant: 'error' });
            } else {
              setDiagnos((prev) => [...prev, row]);
            }
          }}
        />
      </Dialog>
    </>
  );
};
